// extracted by mini-css-extract-plugin
export default {"aiEnabled":"SearchBar_aiEnabled__gv2fU","blinker":"SearchBar_blinker__ApiAc","aiDisabled":"SearchBar_aiDisabled__2WHzx","noCursor":"SearchBar_noCursor__1vRCX"};